import { render, staticRenderFns } from "./MasterLayoutComponent.vue?vue&type=template&id=6a8b939f&"
import script from "./MasterLayoutComponent.vue?vue&type=script&lang=ts&"
export * from "./MasterLayoutComponent.vue?vue&type=script&lang=ts&"
import style0 from "./MasterLayoutComponent.vue?vue&type=style&index=0&id=6a8b939f&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports